module.exports = __webpack_public_path__ + "static/media/authBg.018ab338.jpg";